import React, { useEffect, useState } from "react"
import ProjectPage from "../../../../entities/DashboardPage/HRModule/ProjectPage";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";

function Project() {
  const { showAlert } = useAlert();
  const [projectList, setProjectList] = useState([]);
  const [clear, setClear] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getProjects();
  }, []);
  
  const handleProject = async (project) => {
    setLoading(true);
    try {
      const result = await AuthService.handleProject(project);
      if (result?.success) {
        showAlert(result?.message, "success")
        setLoading(false);
        setOpen(false)
        setClear(true);
        getProjects();
      } else {
        showAlert(result?.message, "success")
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getProjects = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProjectsAdmin();
      if (result?.success) {
        setProjectList(result?.data?.projects || []);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const updateProject = async (project, status, id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.updateProject(project, status, id);
      if (result?.success) {
        showAlert(result?.message, "success")
        LoaderHelper.loaderStatus(false);
        setClear(true);
        getProjects();
        setOpen(false)
      } else {
        showAlert(result?.message, "success")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteProject(id);
      if (result?.success) {
        showAlert(result?.message, "success")
        LoaderHelper.loaderStatus(false);
        setClear(true);
        getProjects();
        setOpen(false)
      } else {
        showAlert(result?.message, "success")
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <ProjectPage handleProject={handleProject} handleDelete={handleDelete} clear={clear} open={open} setOpen={setOpen} updateProject={updateProject} projectList={projectList} loading={loading} />
  )
}

export default Project;